<!-- 表格式代码商品详情 -->
<template>
  <div>
    <table width="100%">
      <thead align="center">
        <tr>
          <th>商品</th>
          <th>小计</th>
          <th>优惠减免金额（元）</th>
          <th>应收金额</th>
          <th>积分抵扣（元）</th>
          <th>加价/减价</th>
          <th>实收金额</th>
        </tr>
      </thead>
      <tbody align="center">
        <tr v-for="(item, index) in detailData.goods" :key="item.id">
          <td
            align="left"
            class="picture_shop_item"
            style="display: flex;align-items: center;"
          >
            <span style="width:60px;height:60px;">
              <img
                :src="item.image_url"
                alt=""
                style="width:50px;height:50px"
              />
            </span>
            <span>
              <p>{{ item.name }}</p>
              <p>数量：{{ item.nums }}</p>
              <p>单价：¥{{ item.price }}</p>
            </span>
          </td>
          <td>
            {{ item.total_amount }}
          </td>
          <td>
            {{ item.promotion_amount }}
          </td>
          <td>
            {{ item.total_amount }}
          </td>
          <td>
            0
          </td>
          <td>
            <span v-if="ReadOnly">{{ item.update_amount }}</span>
            <el-input-number
              size="mini"
              v-model="item.update_amount"
              @change="
                (val,oldval) => {
                  handleChange(val, oldval, index);
                }
              "
              :min="0 - Number(item.price)"
              :max="10"
              label="描述文字"
              v-else
            ></el-input-number>
          </td>
          <td>
            <!-- {{ item.total_amount }} -->
            {{ (Number(item.total_amount) + Number(item.update_amount)).toFixed(2) }}
          </td>
        </tr>
        <tr>
          <td align="left">
            运费：
          </td>
          <td>
            {{detailData.order_freight}}
          </td>
          <td>
            0.00
          </td>
          <td>
            {{detailData.order_freight}}
          </td>
          <td>
            0
          </td>
          <td>
            <span v-if="ReadOnly">{{ detailData.update_freight }}</span>
            <el-input-number
              size="mini"
              v-model="detailData.update_freight"
              :min="0-detailData.order_freight"
              :max="10"
              label="描述文字"
              v-else
              @change="handleFreight"
            ></el-input-number>
          </td>
          <td>
            {{ (Number(detailData.order_freight) + Number(detailData.update_freight)).toFixed(2) }}
          </td>
        </tr>
        <tr>
          <td align="left">
            总计：
          </td>
          <td>
            {{total_compute}}
          </td>
          <td>
            {{total_coupon}}
          </td>
          <td>
            {{total_receiv}}
          </td>
          <td>
            {{total_integral}}
          </td>
          <td>
            {{total_change}}
          </td>
          <td>
            {{total_real}}
          </td>
        </tr>

        <tr v-if="ShowOption">
          <td align="left" colspan="2">
            收货信息：
            <span v-if="!addressshow">
              <span v-if="detailData.ship_type == 1"
                >{{ detailData.address.area
                }}{{ detailData.address.address }}</span
              >
              <span v-if="detailData.ship_type == 2">门店自提</span>
              <span v-if="detailData.ship_type == 3">不需要物流</span>
            </span>
          </td>
          <td colspan="3"></td>
          <td colspan="2">
            <el-button
              size="mini"
              icon="el-icon-edit"
              @click="addressShow"
              v-if="detailData.ship_type != 3"
              >修改</el-button
            >
            <el-button
              icon="el-icon-circle-close-outline"
              size="mini"
              v-clipboard:copy="detailData.address"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              >复制</el-button
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 快递送货 -->
    <el-form
      :model="detailData"
      size="mini"
      label-width="100px"
      v-if="addressshow && detailData.ship_type == '1'"
    >
      <el-form-item label="收货人">
        <el-input v-model="detailData.address.name"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input v-model="detailData.address.mobile"></el-input>
      </el-form-item>
      <el-form-item label="收货人地址" v-if="show_area_option">
        <el-cascader
          :options="options"
          v-model="area_id"
          expand-trigger="hover"
          @change="handleChangeArea"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="收货人地址" v-else>
        <!-- <el-input v-model="detailData.address.area"></el-input> -->
        <span style="margin-right:10px">{{ detailData.address.area }}</span>
        <el-button type="text" @click="show_area_option = true">选择</el-button>
      </el-form-item>

      <el-form-item label="详细地址">
        <el-input v-model="detailData.address.address"></el-input>
      </el-form-item>
    </el-form>
    <!-- 门店自提 -->
    <el-form
      :model="detailData"
      size="mini"
      label-width="100px"
      v-if="addressshow && detailData.ship_type == '2'"
    >
      <el-form-item label="提货人">
        <el-input v-model="detailData.lading.name"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input v-model="detailData.lading.mobile"></el-input>
      </el-form-item>
      <el-form-item label="订单编号">
        {{ detailData.ordersn }}
      </el-form-item>
      <el-form-item label="提货状态">
        {{ detailData.lading.status == 1 ? "未提货" : "已提货" }}
      </el-form-item>
    </el-form>
    <div class="submit_change">
      <el-button
        size="small"
        class="submit_button"
        v-if="addressshow"
        @click="editAddress()"
        >确认修改</el-button
      >
    </div>
  </div>
</template>

<script>
import { OrderDetail, EditAddress } from "@/api/order";
import { areajson } from "@/components/public/area";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props: {
    OrderSn: {
      type: String,
      default: ""
    },
    ShowOption: {
      type: Boolean,
      default: true
    },
    ReadOnly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    OrderSn() {
      this.getOrderDetail();
    }
  },
  data() {
    return {
      detailData: {},
      // 修改收货地址
      addressshow: false,
      revice_money: 0,
      shiptype: 0,
      options: areajson, //调用外部js文件的json数据
      area_id: [],
      show_area_option: false,
      change_price_array: [],
      total_compute: 0,
      total_coupon: 0,
      total_receiv: 0,
      total_integral: 0,
      total_change: 0,
      total_real: 0
    };
  },
  mounted() {
    this.getOrderDetail();
  }, 
  methods: {
    getOrderDetail() {
      var data = {
        token: this.token,
        ordersn: this.OrderSn,
        app_id: this.app_id
      };
      console.log(data);
      OrderDetail(data).then(res => {
        this.detailData = Object.assign({}, res.data);
        this.detailData.goods.forEach(item => {
          this.change_price_array.push({
            id: item.id,
            price: item.update_amount
          });
          //计算合计价格
          this.total_compute += Number(item.total_amount);
          this.total_coupon += Number(item.promotion_amount);
          this.total_receiv += Number(item.total_amount);
          this.total_change += Number(item.update_amount);
          this.total_real += Number(item.amount);
        });
        this.area_id = ["0","0",this.detailData.address.area_id];
        //计算合计价格
        this.total_compute += Number(this.detailData.order_freight); //小计
        this.total_coupon = 0; //优惠
        this.total_receiv += Number(this.detailData.order_freight); //应收
        this.total_integral = 0; //积分满减
        this.total_change += Number(this.detailData.update_freight); //价格变动
        this.total_real += Number(this.detailData.freight); //实收
        this.total_compute = (this.total_compute).toFixed(2);
        this.total_coupon = (this.total_coupon).toFixed(2);
        this.total_receiv = (this.total_receiv).toFixed(2);
        this.total_integral = (this.total_integral).toFixed(2);
        this.total_change = (this.total_change).toFixed(2);
        this.total_real = (this.total_real).toFixed(2);
      });
    },
    // 价格变动
    handleChange(value, oldval, index) {
      var v = Number(value) - Number(oldval);
      this.total_change = (Number(this.total_change) + v).toFixed(2);
      this.total_real = (Number(this.total_real) + v).toFixed(2);
      this.change_price_array[index].price = value;
      // console.log(this.change_price_array);
      this.$emit("changePrice", this.change_price_array);
      // this.revice_money = Number(this.detailData.goods[0].amount) - this.detailData.goods[0].update_amount
    },
    // 修改运费价格
    handleFreight(val,oldval){
      console.log(val);
      console.log(oldval);
      var v = Number(val) - Number(oldval);
      this.total_change = (Number(this.total_change) + v).toFixed(2);
      this.total_real = (Number(this.total_real) + v).toFixed(2);
      this.$emit("changeFreight",val);
    },
    //修改收货地址显示/隐藏
    addressShow() {
      this.addressshow = !this.addressshow;
      if (!this.addressshow) {
        this.show_area_option = false;
      }
    },
    handleChangeArea(value){
      console.log(value)
    },
    //修改收货地址
    editAddress() {
      var data = {
        token: this.token,
        ordersn: this.OrderSn,
        app_id: this.app_id,
        receipt_type: 1,
        name: this.detailData.address.name,
        mobile: this.detailData.address.mobile,
        area_id: this.area_id,
        address: this.detailData.address.address
      };
      console.log(data);
      EditAddress(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getOrderDetail();
          this.addressShow();
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //复制到剪贴板
    onCopy: function() {
      alert("复制成功，快分享给你的小伙伴吧");
    },
    onError: function() {
      alert("复制失败");
    }
  }
};
</script>
<style lang="scss" scoped>
table {
  tr {
    padding: 90px 0;
    border-bottom: 1px solid #f1f1f1;
    td {
      padding: 10px 0px;
    }
  }
}
.el-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    width: 30%;
  }
  padding: 20px 0;
  border-bottom: 1px solid #f1f1f1;
}
.submit_change {
  position: relative;
  bottom: 0;
  right: 0;
  text-align: end;
  .submit_button {
    position: absolute;
    top: -32px;
    right: 110px;
  }
}
</style>
